export default {"src":"/_next/static/media/lead-careers_v.399fed3d.svg","height":88,"width":378};